import React, {useEffect, useRef, useState} from "react";
import useScrollerDots from "../../hooks/useScrollerDots";
import s from "./ComboScroller.module.scss";
import ComboOfferCard from "../../pages/ComboOffers/ComboCard/ComboOfferCard";

const ComboScroller = ({
                           combos,
                           loadMore,
                           hasMore,
                           loading
                       })=>{


    const loaderRef = useRef(null);



    useEffect(()=>{


        const observer =
            new IntersectionObserver(
                (entries)=>{


                    if(
                        entries[0].isIntersecting &&
                        hasMore &&
                        !loading
                    ){

                        loadMore();

                    }


                },
                {
                    threshold:1
                });


        if(loaderRef.current)
            observer.observe(loaderRef.current);



        return ()=>observer.disconnect();


    },[
        hasMore,
        loading
    ]);



    return (

        <div className={s.wrapper}>


            {
                combos.map(combo=>(

                    <div
                        key={combo.id}
                        className={s.item}
                    >

                        <ComboOfferCard
                            combo={combo}
                        />

                    </div>

                ))

            }



            <div
                ref={loaderRef}
                className={s.loader}
            >


                {
                    loading &&
                    "Loading..."
                }


            </div>


        </div>

    )


}

export default ComboScroller;